/** @description Сценарии и этапы при работе с баннерами Buzzoola */
export let EBuzzoolaAnalyticsPayloadType = /*#__PURE__*/function (EBuzzoolaAnalyticsPayloadType) {
  /** @description Тип, данных, который существует до обогащения данными из buzzoola, события до load */
  EBuzzoolaAnalyticsPayloadType["WithoutBuzzoolaData"] = "withoutBuzzoolaData";
  /** @description Тип, данных, который существует в момент и после успешного обогащения данными из buzzoola, события от load и далее */
  EBuzzoolaAnalyticsPayloadType["WithBuzzoolaData"] = "withBuzzoolaData";
  /** @description Тип, данных, который существует в момент и после не успешного обогащения данными из buzzoola, события от error и далее */
  EBuzzoolaAnalyticsPayloadType["WithBuzzoolaErrorData"] = "withBuzzoolaErrorData";
  return EBuzzoolaAnalyticsPayloadType;
}({});